import "./smoothScroll";

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  //分割したい個数を入力
  var division = 9;

  //要素の数を数える
  var divlength = $(".row-thumbnail-post .col-sm-4").length;
  //分割数で割る
  var dlsizePerResult = divlength / division;
  //分割数 刻みで後ろにmorelinkを追加する
  for (var i = 1; i <= dlsizePerResult; i++) {
    $(".row-thumbnail-post .col-sm-4").eq(division * i - 1)
      .after('<span class="morelink link' + i + '"><font>もっと見る</font></span>');
  }
  //最初のli（分割数）と、morelinkを残して他を非表示
  $('.row-thumbnail-post .col-sm-4,.morelink').hide();
  for (var j = 0; j < division; j++) {
    $('.row-thumbnail-post .col-sm-4').eq(j).show();
  }
  $('.morelink.link1').show();

  //morelinkにクリック時の動作
  $('.morelink').click(function() {
    //何個目のmorelinkがクリックされたかをカウント
    var index = $(this).index('.morelink');
    //(クリックされたindex +2) * 分割数 = 表示数
    for (var k = 0; k < (index + 2) * division; k++) {
      $('.row-thumbnail-post .col-sm-4').eq(k).fadeIn();
    }

    //一旦全てのmorelink削除
    $('.morelink').hide();
    //次のmorelink(index+1)を表示
    $('.morelink').eq(index + 1).show();

  });
});


